import PropTypes from "prop-types";

const propTypes = {
  priloha: PropTypes.shape({
    I_AG_ZIADOST: PropTypes.number,
    I_AG_ZIAD_BIN: PropTypes.number,
    FILE_NAME: PropTypes.string,
    FILE: PropTypes.string,
  }),
};

export default propTypes;
